import { i18n } from '../i18n'

export default {
  path: '/profile',
  name: 'profile',
  component: () => import(/* webpackChunkName: 'profile' */ '../views/Profile.vue'),
  children: [
    {
      path: 'student/:id',
      name: 'StudentProfile',
      component: () => import(/* webpackChunkName: 'student-profile' */ '../views/StudentProfile.vue'),
      meta: {
        title: i18n.global.t('default.profile.title') + ' | UG',
        requiresAuth: true,
        type: 'student',
        uri:'/profile/student'
        
      },
      children: [
        {
          path: '',
          name: 'StudentProfileGeneral',
          component: () => import(/* webpackChunkName: 'student-profile-general' */ '../views/Profile/Student/General.vue'),
          meta: {
            title: i18n.global.t('default.profile.general') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        },
        {
          path: 'evaluations',
          name: 'StudentProfileEvaluations',
          component: () => import(/* webpackChunkName: 'student-profile-evaluations' */ '../views/Profile/Student/Evaluations.vue'),
          meta: {
            title: i18n.global.t('default.profile.evaluations') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        },
        {
          path: 'schedule',
          name: 'StudentProfileSchedule',
          component: () => import(/* webpackChunkName: 'student-profile-schedule' */ '../views/Profile/Student/Schedule.vue'),
          meta: {
            title: i18n.global.t('default.profile.schedule') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        },
        {
          path: 'documents',
          name: 'StudentProfileDocuments',
          component: () => import(/* webpackChunkName: 'student-profile-documents' */ '../views/Profile/Student/Documents.vue'),
          meta: {
            title: i18n.global.t('default.profile.documents') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        },
        {
          path: 'exams',
          name: 'StudentProfileExams',
          component: () => import(/* webpackChunkName: 'student-profile-exams' */ '../views/Profile/Student/Exams.vue'),
          meta: {
            title: i18n.global.t('default.profile.exams') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        },
        {
          path: 'applications',
          name: 'StudentProfileApplications',
          component: () => import(/* webpackChunkName: 'student-profile-applications' */ '../views/Profile/Student/Applications.vue'),
          meta: {
            title: i18n.global.t('default.profile.application') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        },
        {
          path: 'family-members',
          name: 'StudentProfileFamilyMembers',
          component: () => import(/* webpackChunkName: 'student-profile-family' */ '../views/Profile/Student/FamilyMembers.vue'),
          meta: {
            title: i18n.global.t('default.profile.family-members') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
            uri:'/profile/student'
          }
        }
      ]
    },
    {
      path: 'person/:id',
      name: 'PersonProfile',
      component: () => import(/* webpackChunkName: 'person-profile' */ '../views/PersonProfile.vue'),
      meta: {
        title: i18n.global.t('default.profile.title') + ' | UG',
        requiresAuth: true,
        type: 'person',
        uri:'/profile/person'
      },
      children: [
        {
          path: '',
          name: 'PersonProfileGeneral',
          component: () => import(/* webpackChunkName: 'person-profile-general' */ '../views/Profile/Person/General.vue'),
          meta: {
            title: i18n.global.t('default.profile.general') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
              uri:'/profile/person'
            
          }
        },
        {
          path: 'education',
          name: 'PersonProfileEducation',
          component: () => import(/* webpackChunkName: 'person-profile-evaluations' */ '../views/Profile/Person/Education.vue'),
          meta: {
            title: i18n.global.t('default.profile.education.title') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
              uri:'/profile/person'
          }
        },
        {
          path: 'work-experience',
          name: 'PersonProfileWorkExperience',
          component: () => import(/* webpackChunkName: 'person-profile-work-experience' */ '../views/Profile/Person/WorkExperience.vue'),
          meta: {
            title: i18n.global.t('default.profile.work-experience.title') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
              uri:'/profile/person'
          }
        },
        {
          path: 'contracts',
          name: 'PersonProfileContracts',
          component: () => import(/* webpackChunkName: 'person-profile-contracts' */ '../views/Profile/Person/Contracts.vue'),
          meta: {
            title: i18n.global.t('default.profile.contracts.title') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
              uri:'/profile/person'
          }
        },
        {
          path: 'schedule',
          name: 'PersonProfileSchedule',
          component: () => import(/* webpackChunkName: 'person-profile-schedule' */ '../views/Profile/Person/Schedule.vue'),
          meta: {
            title: i18n.global.t('default.profile.schedule') + ' - ' + i18n.global.t('default.profile.title') + ' | UG',
            requiresAuth: true,
              uri:'/profile/person'
          }
        }
      ]
    }
  ]
}
